type FloatingCloseButtonProps = {
  onClick: () => void;
  iconClass?: string;
  ariaLabel?: string;
  className?: string;
};

export default function FloatingCloseButton({
  onClick,
  iconClass = "ri-fullscreen-exit-line",
  ariaLabel,
  className = "fixed top-4 right-4 z-[10002] opacity-0 hover:opacity-100",
}: FloatingCloseButtonProps) {
  return (
    <button
      onClick={onClick}
      aria-label={ariaLabel}
      className={`w-10 h-10 bg-black/40 hover:bg-black/60 text-white rounded-full flex items-center justify-center transition-all cursor-pointer backdrop-blur-sm ${className}`}
    >
      <i className={`${iconClass} text-xl`}></i>
    </button>
  );
}
